
import { mapMutations } from 'vuex'
import NewsFlashView from '~/components/Common/NewsFlashView'
import Content from '~/components/Common/NewsFlashView/FlashHtmlFileType'

export default {
    name: 'FlashHtmlFile',
    components: { NewsFlashView, Content },
    props: {
        newsType: String,
        menuType: {
            type: String,
            default: null,
        },
        pageTitle: String,
        date: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            colKey: ['title', 'sendDate'],
        }
    },
    created() {
        this.SET_COL(this.colKey)
    },
    methods: {
        ...mapMutations('board', ['SET_COL']),
    },
}
